import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import English from './locales/en/translation.json';
import French from './locales/fr/translation.json';

let resources = {
    en: English,
    fr: French,
}
i18n
  .use(initReactI18next)
  .init({
    nsSeparator: false,
    keySeparator: false,
    resources,
    lng: 'en',
    // debug: true,

    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;